import { Box } from '@mui/material';
import EnumListComponent from './EnumListComponent';
import AddEnumModal from './AddEnumModal';
import MergeAdminModal from './MergeAdminModal';
import AddEnumTypesModal from './AddEnumTypesModal';
import EnumTypesListComponent from './EnumTypesListComponent';
import MergeTypesAdminModal from './MergeTypesAdminModal';
import { useState } from 'react';
import { IssueAndServiceSharedValues } from '../../shared/constants/IssueAndServiceKeys';
import { adminCardWrapperSx } from './adminStyles';

const listContainerStyles = {
  ...adminCardWrapperSx,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.75rem',
  minHeight: 0,
};

const EnumListContainer = ({
  itemType,
  enumItems,
  addButton,
  enumModalOpen,
  setEnumModalOpen,
  isEditing,
  setIsEditing,
  isMerging,
  setIsMerging,
  selectedEnum,
  setSelectedEnum,
}) => {
  const [whatIsBeingMergedForTypes, setWhatIsBeingMergedForTypes] = useState('Types'); // Type Categories or Types
  const [mergingItems, setMergingItems] = useState([]);
  return (
    <Box sx={listContainerStyles}>
      {itemType === IssueAndServiceSharedValues.type ? (
        <EnumTypesListComponent
          enumItems={enumItems}
          itemType={itemType}
          addButton={addButton}
          setEnumModalOpen={setEnumModalOpen}
          setIsEditing={setIsEditing}
          setSelectedEnum={setSelectedEnum}
          isMerging={isMerging}
          setIsMerging={setIsMerging}
          setMergingItems={setMergingItems}
          whatIsBeingMergedForTypes={whatIsBeingMergedForTypes}
          setWhatIsBeingMergedForTypes={setWhatIsBeingMergedForTypes}
        />
      ) : (
        <EnumListComponent
          enumItems={enumItems}
          itemType={itemType}
          addButton={addButton}
          setEnumModalOpen={setEnumModalOpen}
          setIsEditing={setIsEditing}
          setSelectedEnum={setSelectedEnum}
          isMerging={isMerging}
          setIsMerging={setIsMerging}
          setMergingItems={setMergingItems}
        />
      )}

      {enumModalOpen &&
        (itemType === IssueAndServiceSharedValues.type ? (
          <AddEnumTypesModal
            open={enumModalOpen}
            setOpen={setEnumModalOpen}
            existingItems={enumItems}
            editMode={isEditing}
            setEditMode={setIsEditing}
            selectedItem={selectedEnum}
          />
        ) : (
          <AddEnumModal
            open={enumModalOpen}
            setOpen={setEnumModalOpen}
            itemType={itemType}
            existingItems={enumItems}
            editMode={isEditing}
            setEditMode={setIsEditing}
            selectedItem={selectedEnum}
          />
        ))}
      {isMerging &&
        (itemType === IssueAndServiceSharedValues.type ? (
          <MergeTypesAdminModal
            openMergeAdmin={isMerging}
            setOpenMergeAdmin={setIsMerging}
            selectedItem={selectedEnum}
            enumItems={enumItems}
            mergingItems={mergingItems}
            whatIsBeingMergedForTypes={whatIsBeingMergedForTypes}
            setWhatIsBeingMergedForTypes={setWhatIsBeingMergedForTypes}
          />
        ) : (
          <MergeAdminModal
            itemType={itemType}
            openMergeAdmin={isMerging}
            setOpenMergeAdmin={setIsMerging}
            selectedItem={selectedEnum}
            enumItems={enumItems}
            mergingItems={mergingItems}
          />
        ))}
    </Box>
  );
};

export default EnumListContainer;
